export default __webpack_public_path__ + "static/media/poliviews.f9a140fc.gif";